import { BRAND_DETAILS_ACTION } from "core/constants/Actions";
import { Action } from "core/models/ActionTypes";
import { Brand } from "core/models/Brand";

const intialState: { brand: Brand | null; isLoading: boolean } = {
  brand: null,
  isLoading: false,
};

interface ActionType extends Action {
  payload: { brand: Brand };
}

export default function brandDetailsReducer(state = intialState, action: ActionType) {
  switch (action.type) {
    case BRAND_DETAILS_ACTION.REQUEST:
      return { ...state, isLoading: true };
    case BRAND_DETAILS_ACTION.SUCCESS:
      return { ...state, brand: action.payload.brand, isLoading: false };
    case BRAND_DETAILS_ACTION.FAILURE:
      return { ...state, isLoading: false };
    case BRAND_DETAILS_ACTION.RESET:
      return { ...state, ...intialState };
    default:
      return state;
  }
}
